import React, { useContext } from "react";
import Logo from "../../assets/logo/logo.svg";
import "./Footer.css";
import { Context } from "../../context/Context";
import { Link } from "react-router-dom";
import config from "../../config.json";
import { landingContent } from "../landing/content/landingContent";
import { Mail, Phone, Linkedin, Instagram, Twitter } from "lucide-react";

export const Footer = () => {
  const EmailUrl = config.EMAIL;
  const WhatsUrl = config.WHATSUP;
  const Linkedinurl = config.LINKEDIN;
  const Instaurl = config.INSTA;
  const Xurl = config.X;
  const { lang } = useContext(Context);
  const t = (landingContent[lang] || landingContent.en).footer;

  const renderLink = (item, className) => {
    if (!item.to) {
      return (
        <span className={className} key={item.key}>
          {item.label}
        </span>
      );
    }
    return (
      <Link to={item.to} className={className} key={item.key}>
        {item.label}
      </Link>
    );
  };

  return (
    <footer className={`footer ${lang === "ar" ? "ar" : "en"}`}>
      <div className="footer-in">
        <div className="footer-top">
          <Link to="/" className="footer-logo-link">
            <img src={Logo} alt="LUD" className="footer-logo" />
          </Link>
          <nav className="footer-nav">
            {t.nav.map((item) => renderLink(item, "footer-nav-link"))}
          </nav>
        </div>

        <div className="footer-social-icons">
          <a
            href={EmailUrl}
            className="footer-social-icon footer-nav-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Mail size={16} className="icon-clickable" />
            <p>info@lud-sa.app</p>
          </a>
          <a
            href={WhatsUrl}
            className="footer-social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Phone size={16} className="icon-clickable" />
            <p>+966547179368</p>
          </a>
          <a
            href={Linkedinurl}
            className="footer-social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin size={16} className="icon-clickable" />
          </a>
          <a
            href={Instaurl}
            className="footer-social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Instagram size={16} className="icon-clickable" />
          </a>
          <a
            href={Xurl}
            className="footer-social-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Twitter size={16} className="icon-clickable" />
          </a>
        </div>

        <div className="footer-rule" />

        <div className="footer-legal-row">
          <div className="footer-legal">
            {t.legal.map((item) => renderLink(item, "footer-legal-link"))}
          </div>
          <span className="footer-copy">{t.copyright}</span>
        </div>
      </div>
    </footer>
  );
};
